import {unknown as defaultIcon} from '@sail/icons/react/FlagIcon';
import {makeDynamicIconGetter} from './dynamicIconGetter';

export const getFlagIcon = makeDynamicIconGetter<string>({
  load: () => import('@sail/icons/react/FlagIcon'),
  defaultIcon,
  name: 'FlagIcon',
});
